// extracted by mini-css-extract-plugin
export default {"container":"DeliveryHistory_container__-yK0n"};